import { AreaChart, Area, YAxis, XAxis, CartesianGrid } from 'recharts';

export const formatPercentageTick = (tick: number) =>
    `${tick}%`
;

export const StorageChart = ({ fromDate, toDate, ticks, data, tickFormatter }: any) =>
    <AreaChart width={ 1024 } height={ 180 } data={ data }>
        <defs>
            <linearGradient id="lg" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8884d8" stopOpacity={ .8 }/>
                <stop offset="95%" stopColor="#8884d8" stopOpacity={ .1 }/>
            </linearGradient>
        </defs>
        <Area type="monotone" dataKey="value" fillOpacity="1" fill="url(#lg)" isAnimationActive={ false } activeDot={ { stroke: '#fff', fill: '#8884d8', strokeWidth: 1 } }/>
        <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
        <XAxis type="number" domain={ [ fromDate, toDate ] } dataKey="name" ticks={ ticks } tickFormatter={ tickFormatter } /* TODO: fontSize=".8em" */ />
        <YAxis type="number" domain={ [ 0, 100 ] } ticks={ [ 0, 25, 50, 75, 100 ] } tickFormatter={ formatPercentageTick }/>
    </AreaChart>
;
